import React, { useState, Fragment } from 'react';
import CountUp from 'react-countup';
import './StudioHeadContent.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { Waypoint } from 'react-waypoint';

function StudioHeadContent(props) {
    const [ viewPortEntered, setViewPortEntered ] = useState(false); // global markets
    const [ viewPortEntered2, setViewPortEntered2 ] = useState(false); // sound stages
    const [ viewPortEntered3, setViewPortEntered3 ] = useState(false); // production vehicles

    function handleWaypointEnter() {
        setViewPortEntered(true);
    }

    function handleWaypointEnter2() {
        setViewPortEntered2(true);
    }
    
    function handleWaypointEnter3() {
        setViewPortEntered3(true);
    }

    return (
        <section className="section studio-head-content empty">
            <div className="container">
                <div className="columns is-multiline is-mobile">
                    <div className="column is-12-mobile is-10-desktop is-offset-1-desktop">
                        {/* <div className="sunset-desc"> */}
                            {/* {studioCTA[0] && <div dangerouslySetInnerHTML={createMarkup(studioCTA[0].description)} />} */}

                            {/* <ScrollAnimation duration={2} animateOnce={true} animateIn={'fadeIn'} initiallyVisible={false}>
                                <div className="stats-grid">
                                    <div>
                                        <Waypoint onEnter={handleWaypointEnter}>
                                            <div className="stat-number">
                                                {viewPortEntered &&
                                                    <CountUp start={0} end={6} duration={2.5} />
                                                }
                                            </div>
                                        </Waypoint>
                                        <div className="stat-title">
                                            <div>GLOBAL MEDIA</div>
                                            <div>MARKETS</div>
                                        </div>
                                    </div>
                                    <div>
                                        <Waypoint onEnter={handleWaypointEnter2}>
                                            <div className="stat-number lean-left">
                                                {viewPortEntered2 &&
                                                    <Fragment>
                                                        <span className="around">~</span>
                                                        <CountUp start={0} end={95} duration={2.5} />
                                                    </Fragment>
                                                }
                                            </div>
                                        </Waypoint>

                                        <div className="stat-title">
                                            <div>SOUND</div>
                                            <div>STAGES</div>
                                        </div>
                                    </div>
                                    <div>
                                        <Waypoint onEnter={handleWaypointEnter3}>
                                            <div className="stat-number lean-left">
                                                {viewPortEntered3 &&
                                                    <Fragment>
                                                        <span className="around">~</span>
                                                        <CountUp start={0} end={1800} duration={2.5} separator="," />
                                                    </Fragment>
                                                }
                                            </div>
                                        </Waypoint>

                                        <div className="stat-title">
                                            <div>PRODUCTION</div>
                                            <div>VEHICLES</div>
                                        </div>
                                    </div>
                                </div>
                            </ScrollAnimation> */}
                            {/* <p className="big">
                                <ScrollAnimation duration={1.5} animateOnce={true} animateIn={'fadeIn'} initiallyVisible={false}>
                                    Hudson Pacific has been at the forefront of Hollywood&#39;s renaissance for more than a decade. By executing on our vision to
                                    deliver high-quality sound stages alongside a robust array of production services, we&#39;ve created a premier, streamlined
                                    solution for today&#39;s leading media companies.
                                </ScrollAnimation>
                            </p> */}
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default StudioHeadContent;
